import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { FC } from 'react';
import { Trans } from '@lingui/macro';

export const ForbiddenScreen: FC = () => {
  return (
    <Wrapper>
      <Typography variant="h3" align="center">
        <Trans>Nemáte oprávnění pro tuto stránku.</Trans>
      </Typography>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
`;
